import { booleanAttribute, ChangeDetectionStrategy, Component, effect, ElementRef, inject, input, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Checkbox } from "primeng/checkbox";
import { FormControlBaseDirective } from "../form-control-base.directive";

let nextId = 0;

@Component({
    selector: "kno2-form-checkbox",
    imports: [FormsModule, Checkbox],
    templateUrl: "./form-checkbox.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormCheckboxComponent extends FormControlBaseDirective {
    public readonly label = input<string>();
    public readonly inputId = input<string>(`kno2-form-checkbox-${nextId++}`);
    public readonly autofocus = input<boolean, unknown>(false, { transform: booleanAttribute });

    protected readonly checked = signal(false);

    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

    private autofocusEffect = effect(() => {
        if (this.autofocus()) {
            queueMicrotask(() => {
                this.host.nativeElement.querySelector<HTMLInputElement>("input")?.focus();
                this.autofocusEffect.destroy();
            });
        }
    });

    protected applyValue(value: unknown): void {
        this.checked.set(!!value);
    }

    protected handleChange(value: boolean): void {
        this.checked.set(value);
        this.emitChange(value);
    }
}
